<template>
  <div class="layer-switcher">
    <layer-switcher-item
      v-for="(layer, layerIndex) in sortedLayers"
      :key="layerIndex"
      :layer="layer"
      @listenSwitchState="setLayerState"
    />
  </div>
</template>
<script>
import { THREDDS_MSP, LOCAL_GEOJSON } from "@/config/data-providers.js";
import LayerSwitcherItem from "./../components/LayerSwitcherItem";
import { mapActions } from "vuex";

export default {
  components: {
    "layer-switcher-item": LayerSwitcherItem
  },
  props: {
    layers: {
      type: Array,
      required: true
    },
    metadata: {
      type: Object,
      required: true,
      default() {
        return {
          groupName: "",
          provider: ""
        };
      }
    }
  },
  computed: {
    sortedLayers() {
      var sortedLayers = this.layers;
      return sortedLayers.sort(this.$_utilsMixin_sortArray("alias"));
    }
  },
  methods: {
    ...mapActions("map", {
      changeSuitabilityLayer: "changeSuitabilityLayer"
    }),
    setLayerState(layer) {
      if (layer.visible) {
        this.$emit("resetOnLayerChange");
        /* Reactivate actual layer's switch */
        layer.visible = true;
      }
      switch (this.metadata.provider) {
        case THREDDS_MSP.name:
          this.changeSuitabilityLayer({
            layer: layer,
            metadata: this.metadata,
            show: layer.visible
          });
          break;
        case LOCAL_GEOJSON.name:
          this.changeGeoJSONLayer({
            layer: layer,
            metadata: this.metadata,
            show: layer.visible
          });
          break;
      }
    }
  }
};
</script>
<style scoped>
.vs-switch {
  height: 14px;
}

.vs-switch >>> .vs-circle-switch {
  width: 10px;
  height: 10px;
}

.vs-switch.vs-switch-active >>> .vs-circle-switch {
  margin-left: calc(100% - 14px);
}

.switch-display {
  display: inline-flex;
  padding: 10px;
  font-size: 0.8rem;
}
.switch-label {
  margin-left: 10px;
}
.layer-switcher {
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  padding: 5px;
}
</style>
